/**
* GameContextManager.js
* 
* Created on 13-mei-2014, 16:47:08
*
* @author Ivo Swartjes for Ranj
**/

import EventDispatcher from "/lib/html5-software-library/src/ranj/util/EventDispatcher";
import GameContext from "./GameContext";
import NGTDialogPlayer from "../../../dialog/NGTDialogPlayer";
import NGTScenarioPlayer from "../../../scenario/NGTScenarioPlayer";
import DefaultDialogPlayerEvent from "../../../../../../lib/html5-software-library/src/ranj/eng/dialog/framework/player/DefaultDialogPlayerEvent";
import HierarchicalDialogPlayer, { HierarchicalDialogPlayerEvent } from "../../../../../../lib/html5-software-library/src/ranj/eng/dialog/framework/player/HierarchicalDialogPlayer";
import { isNull } from "../../../../../../lib/html5-software-library/src/ranj/util/TypeUtil";
import DecisionContent from "../../../../../../lib/html5-software-library/src/ranj/eng/content/DecisionContent";
import QuizContentComponent from "../../../../../../lib/html5-software-library/src/ranj/eng/content/QuizContentComponent";

export default class GameContextManager extends EventDispatcher {
    constructor(revisionToolGateway) {
        super();

        this._revisionToolGateway = revisionToolGateway;
        this._contentByDialogPlayer = new Map();

        this._setGlobalContext(new GameContext(GameContext.GLOBAL));

        this._handleDialogEnterDialogStateBound = this._handleDialogEnterDialogState.bind(this);
        this._handleDialogExitDialogStateBound = this._handleDialogExitDialogState.bind(this);
        this._handleSubDialogStartedBound = this._handleSubDialogStarted.bind(this);
        this._handleSubDialogEndedBound = this._handleSubDialogEnded.bind(this);
    }

    registerContentPlayer(contentPlayer) {
        if (contentPlayer instanceof NGTDialogPlayer) {
            this._registerDialogPlayer(contentPlayer.getDialogPlayer(), contentPlayer.getContent());
        } else if (contentPlayer instanceof NGTScenarioPlayer) {
            this._registerStoryPlayer(contentPlayer.getStoryPlayer());
        }
    }

    deregisterContentPlayer(contentPlayer) {
        if (contentPlayer instanceof NGTDialogPlayer) {
            this._deregisterDialogPlayer(contentPlayer.getDialogPlayer());
        } else if (contentPlayer instanceof NGTScenarioPlayer) {
            this._deregisterStoryPlayer(contentPlayer.getStoryPlayer());
        }
    }

    getGlobalContext() {
        return this._globalContext;
    }

    getScenarioContext() {
        return this._scenarioContext;
    }

    getDialogContext() {
        return this._dialogContext;
    }

    _registerDialogPlayer(dialogPlayer, content) {
        this._contentByDialogPlayer.set(dialogPlayer, content);

        dialogPlayer.addEventListener(DefaultDialogPlayerEvent.ENTER_DIALOG_STATE, this._handleDialogEnterDialogStateBound);
        dialogPlayer.addEventListener(DefaultDialogPlayerEvent.EXIT_DIALOG_STATE, this._handleDialogExitDialogStateBound);

        if (dialogPlayer instanceof HierarchicalDialogPlayer) {
            dialogPlayer.addEventListener(HierarchicalDialogPlayerEvent.SUB_DIALOG_START, this._handleSubDialogStartedBound);
            dialogPlayer.addEventListener(HierarchicalDialogPlayerEvent.SUB_DIALOG_END, this._handleSubDialogEndedBound);
        }
    }

    _handleSubDialogStarted({ data }) {
        this._registerDialogPlayer(data.subPlayer, data.subPlayerDialogContent);
    }

    _handleSubDialogEnded({ data }) {
        this._deregisterDialogPlayer(data.subPlayer, data.subPlayerDialogContent);
    }

    _registerStoryPlayer(storyPlayer) {

    }

    _deregisterDialogPlayer(dialogPlayer, content) {
        dialogPlayer.removeEventListener(DefaultDialogPlayerEvent.ENTER_DIALOG_STATE, this._handleDialogEnterDialogStateBound);
        dialogPlayer.removeEventListener(DefaultDialogPlayerEvent.EXIT_DIALOG_STATE, this._handleDialogExitDialogStateBound);

        if (dialogPlayer instanceof HierarchicalDialogPlayer) {
            dialogPlayer.removeEventListener(HierarchicalDialogPlayerEvent.SUB_DIALOG_START, this._handleSubDialogStartedBound);
            dialogPlayer.removeEventListener(HierarchicalDialogPlayerEvent.SUB_DIALOG_END, this._handleSubDialogEndedBound);
        }

        this._contentByDialogPlayer.delete(dialogPlayer, content);
    }

    _deregisterStoryPlayer(storyPlayer) {

    }

    _handleDialogEnterDialogState({ target }) {
        const newDialogState = target.getCurrentCommandSequence();

        const stateID = newDialogState.id;

        let contentID;
        const content = this._contentByDialogPlayer.get(target);
        if (!isNull(content)) {
            if (!isNull(QuizContentComponent) && content instanceof QuizContentComponent) {
                contentID = content.getQuizDialogID();
            } else {
                contentID = content.getDialogID();
            }
        }

        this._setDialogContext(new GameContext(GameContext.DIALOG_STATE, contentID, stateID));
    }

    _handleDialogExitDialogState(event) {
        this._setDialogContext(null);
    }

    _setScenarioContext(value) {
        this._scenarioContext = value;

        this._revisionToolGateway.setScenarioContext(this._scenarioContext);
    }

    _setGlobalContext(value) {
        this._globalContext = value;

        this._revisionToolGateway.setGlobalContext(this._globalContext);
    }

    _setDialogContext(value) {
        this._dialogContext = value;

        this._revisionToolGateway.setDialogContext(this._dialogContext);
    }
}
